<template>
    <div>
        <cotton-echarts :show-card-header='true'
                        :loading='chartLoadingStatus.newUserLoadingStatus'
                        :chart-option='showNewUserNumber ? charOption.newUserNumberOption : charOption.newUserProportionOption'>
            <template #echarts-header>
                <el-row :gutter='30'>
                    <el-col :span='7'>
                        <el-button :disabled='showNewUserNumber' style='float: left; padding: 3px 0'
                                   @click='showNewUserNumber = true' type='text'>单日新增人数
                        </el-button>
                        &nbsp;&nbsp;
                        <el-button :disabled='!showNewUserNumber' style='float: left; padding: 3px 0'
                                   @click='showNewUserNumber = false' type='text'>单日新增人数占比
                        </el-button>
                        &nbsp;&nbsp;
                        <el-button :disabled='!chartLoadingStatus.newUserLoadingStatus' style='float: left; padding: 3px 0'
                                   @click='getList()' type='text'>刷新</el-button>
                        &nbsp;&nbsp;
                        <el-button style='float: left; padding: 3px 0' @click='reset()' type='text'>重置</el-button>
                    </el-col>
                    <el-col :span='17'>
                        <el-select clearable multiple v-model='queryParams.eventIdList' filterable
                                   placeholder='请选择'>
                            <el-option
                                v-for='item in trackEventList'
                                :key='item.id'
                                :label='item.eventName'
                                :value='item.id'>
                            </el-option>
                        </el-select>
                        
                        &nbsp;&nbsp;
                        <el-date-picker
                            v-model='timePicker.pickerTimeValue'
                            type='datetimerange'
                            align='right'
                            unlink-panels
                            range-separator='至'
                            start-placeholder='开始日期'
                            end-placeholder='结束日期'
                            value-format='yyyy-MM-dd HH:mm:ss'
                            @blur='handleTimePickerBlur'
                            :picker-options='timePicker.pickerOptions'>
                        </el-date-picker>
                        
                        &nbsp;&nbsp;
                        <el-radio-group ref='timeUnitButGroup' @input='handleTimeUnitChange' v-model="queryParams.timeUnitType">
                            <el-radio-button label="HOUR">小时</el-radio-button>
                            <el-radio-button label="DAY">天</el-radio-button>
                            <el-radio-button label="WEEK">周</el-radio-button>
                            <el-radio-button label="MONTH">月</el-radio-button>
                        </el-radio-group>
                        
                        &nbsp;&nbsp;
                        <el-button icon='el-icon-search' type='primary' @click='getList'>搜索</el-button>
                    </el-col>
                </el-row>
            </template>
        </cotton-echarts>
        
        <el-card shadow='never' class='box-card' style='margin-top: 2rem'>
            <div slot='header' class='clearfix'>
                <span>每日新增详细数据</span>
                <el-alert
                    style='margin-top: 1rem;'
                    title='下面展示的数据中，如果客户端标识(clientTag)前存在user_，则user_后面的值为我们系统中的玩家id'
                    type='success'
                    :closable='false'>
                </el-alert>
            </div>
            <el-collapse @change='handleChangeCollapse' v-model='collapseActiveName' accordion>
                <el-collapse-item v-for='(value, key) in everyDayNewUserMap' :key='key'
                                  :title='computeCollapseTitle(value)'
                                  :name='computeCollapseUnique(value)'>
                    <el-descriptions :column='1' :colon='false'>
                        <el-descriptions-item label='当日新增'>
                            <span style='color: #F56C6C'>{{ value[1]['currentUserCount'] }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label='新增占比'>
                            <span style='color: #F56C6C'>{{ value[1]['percentage'] }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label='当日总人数'>
                            <span style='color: #F56C6C'>{{ value[1]['totalUserCount'] }}</span>
                        </el-descriptions-item>
                        <el-descriptions-item label='新增玩家客户端标识'>
                            <div>
                                <ul class='new-user-client-tag'>
                                    <li v-for='(item, index) in singleTimeUnitUser.userList' :key='index'>
                                        <span>{{ item.newClientTag }}</span>&nbsp;&nbsp;<el-tag size='mini'
                                                                                             v-if='computeIsAccountUserId(item.newClientTag)'>
                                        真实UserId
                                    </el-tag>
                                    </li>
                                </ul>
                                
                                <el-pagination
                                    style='margin-bottom: 1rem;'
                                    :current-page='singleTimeUnitUser.queryParams.pageNum'
                                    :page-size='singleTimeUnitUser.queryParams.pageSize'
                                    :total='singleTimeUnitUser.queryParams.total'
                                    background
                                    layout='prev, pager, next'
                                    @current-change='handlePagination'>
                                </el-pagination>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </el-collapse-item>
            </el-collapse>
        </el-card>
    </div>
</template>

<script>
import { defineComponent } from 'vue';
import { trackAnalyseApi } from '@api/Track/trackAnalyse';
import { projectInfoApi } from '@api/ProjectInfo';
import bus from '@/components/common/bus';
import { message } from '@/utils/message';
import { trackEventApi } from '@api/Track/trackEvent';

export default defineComponent({
    name: 'TrackSummary',
    data() {
        return {
            queryParams: {
                projectAppId: undefined,
                eventId: undefined,
                eventIdList: undefined,
                startTime: undefined,
                endTime: undefined,
                timeUnitType: 'DAY'
            },
            projectInfo: {},
            newUserChartResult: {},
            chartLoadingStatus: {
                newUserLoadingStatus: false
            },
            showNewUserNumber: true,
            charOption: {
                showOptions: {},
                newUserProportionOption: {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params, ticket, callback) => {
                            if (!params || params.length === 0) {
                                return '';
                            }
                            let data = params[0].data;
                            let clientTagList = data[4];
                            return `<p>新增人数: <span style='color: #F56C6C'>${data[4]}</span></p>
<p>当前活跃人数: <span style='color: #F56C6C'>${data[5]}</span></p>
<p>占比: <span style='color: #F56C6C'>${data[1]}</span></p><p>日期: <span style='color: #F56C6C'>${data[0]}</span></p>`;
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {
                                show: true,
                                excludeComponents: ['toolbox'],
                                pixelRatio: 2
                            }
                            
                        }
                    },
                    dataset: [
                        {
                            dimensions: ['dateTime', 'percentage', 'proportion', 'timestamp', 'currentUserCount', 'totalUserCount'],
                            source: []
                        },
                        {
                            transform: {
                                type: 'sort',
                                config: { dimension: 'timestamp', order: 'asc' }
                            }
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'inside',
                        }
                    ],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 'auto',
                            rotate: 25
                        },
                        name: '日期'
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            interval: 'auto',
                            formatter: {
                                month: '{MMMM}',
                                day: '{d}日',
                            }
                        },
                        name: '新增/活跃',
                        position: 'left'
                    },
                    series: {
                        type: 'line',
                        smooth: true,
                        encode: { x: 'dateTime', y: 'proportion' },
                        datasetIndex: 1
                        
                    }
                },
                newUserNumberOption: {
                    title: {
                        text: ''
                    },
                    tooltip: {
                        trigger: 'axis',
                        formatter: (params, ticket, callback) => {
                            if (!params || params.length === 0) {
                                return '';
                            }
                            let data = params[0].data;
                            let clientTagList = data[4];
                            return `<p>新增人数: <span style='color: #F56C6C'>${data[4]}</span></p>
<p>当前活跃人数: <span style='color: #F56C6C'>${data[5]}</span></p>
<p>占比: <span style='color: #F56C6C'>${data[1]}</span></p><p>日期: <span style='color: #F56C6C'>${data[0]}</span></p>`;
                        }
                    },
                    toolbox: {
                        show: true,
                        feature: {
                            saveAsImage: {
                                show: true,
                                excludeComponents: ['toolbox'],
                                pixelRatio: 2
                            }
                            
                        }
                    },
                    dataset: [
                        {
                            dimensions: ['dateTime', 'percentage', 'proportion', 'timestamp', 'currentUserCount', 'totalUserCount'],
                            source: []
                        },
                        {
                            transform: {
                                type: 'sort',
                                config: { dimension: 'timestamp', order: 'asc' }
                            }
                        }
                    ],
                    dataZoom: [
                        {
                            type: 'inside',
                        }
                    ],
                    xAxis: {
                        type: 'category',
                        axisLabel: {
                            interval: 'auto',
                            rotate: 25,
                        },
                        name: '日期'
                    },
                    yAxis: {
                        type: 'value',
                        axisLabel: {
                            interval: 'auto',
                            formatter: '{value}'
                        },
                        name: '新增',
                        position: 'left'
                    },
                    series: {
                        type: 'line',
                        smooth: true,
                        encode: { x: 'dateTime', y: 'currentUserCount' },
                        datasetIndex: 1
                        
                    }
                }
            },
            singleTimeUnitUser: {
                queryParams: {
                    total: 0,
                    pageNum: 1,
                    pageSize: 15,
                    startTimeStr: undefined,
                    timeUnitType: undefined,
                    projectAppId: undefined,
                    eventIdList: undefined
                },
                userList: []
            },
            everyDayNewUserMap: new Map,
            collapseActiveName: '',
            timePicker: {
                pickerTimeValue: [],
                pickerOptions: {
                    shortcuts: [
                        {
                            text: '最近一周',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近一个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                picker.$emit('pick', [start, end]);
                            }
                        }, {
                            text: '最近三个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                picker.$emit('pick', [start, end]);
                            }
                        },
                        {
                            text: '最近五个月',
                            onClick(picker) {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 150);
                                picker.$emit('pick', [start, end]);
                            }
                        }
                        ]
                }
            },
            trackEventList: []
        };
    },
    created() {
        this.setInitValue()
        if (this.queryParams.projectAppId) {
            bus.$emit('queriedTrackProjectAppId', this.queryParams.projectAppId)
        }
        if (this.queryParams.eventId) {
            bus.$emit('queriedTrackEventId', this.queryParams.eventId)
        }
        
        bus.$on('selectedTrackProjectAppId', this.handleSelectedTrackProjectAppIdEvent)
    },
    computed: {
        computeCollapseTitle() {
            return (value) => {
                return `${value[0]}   新增${value[1]['currentUserCount']}人`;
            };
        },
        computeCollapseUnique() {
            return (value) => {
                return `${value[0]}`;
            };
        },
        computeIsAccountUserId() {
            return (clientTag) => {
                return clientTag.startsWith("user_");
                
            };
        }
    },
    methods: {
        reset() {
            this.queryParams = {
                projectAppId: this.queryParams.projectAppId,
                eventId: undefined,
                startTime: undefined,
                endTime: undefined,
                timeUnitType: 'DAY'
            }
            this.timePicker.pickerTimeValue = []
            this.getList()
        },
        getList() {
            this.chartLoadingStatus.newUserLoadingStatus = false;
            this.charOption.newUserNumberOption.dataset[0].source = [];
            this.charOption.newUserProportionOption.dataset[0].source = [];
            if (!this.queryParams.projectAppId || this.queryParams.projectAppId.indexOf('undefined') === 0) {
                message.error('请选择项目!')
                return
            }
            
            projectInfoApi.query({ appId: this.queryParams.projectAppId }).then(result => {
                if (result.code === 200) {
                    this.projectInfo = result.data.result[0];
                }
            });
            
            trackAnalyseApi.newUser(this.queryParams).then(result => {
                if (result.code === 200) {
                    this.newUserChartResult = result.data;
                    this.setNewUserOption();
                }else {
                    this.chartLoadingStatus.newUserLoadingStatus = true;
                }
            });
            
            trackEventApi.queryTrackEvent({projectAppId: this.queryParams.projectAppId, pageNum: 1, pageSize: 100000}).then(result => {
                if (result.code === 200) {
                    this.trackEventList = result.data.result
                }
            })
        },
        setNewUserOption() {
            this.everyDayNewUserMap = new Map;
            this.charOption.newUserProportionOption.dataset[0].source = [];
            this.charOption.newUserProportionOption.title.text = '最近' + this.newUserChartResult.chartName + '单日新增人数占比';
            if (!this.newUserChartResult.addictionData) {
                message.success('无新增用户数据!');
                this.chartLoadingStatus.newUserLoadingStatus = true;
                return;
            }
            let addictionData = this.newUserChartResult.addictionData;
            const newUserKeys = Object.keys(addictionData);
            if (newUserKeys.length === 0) {
                this.handleEmptyData()
                return;
            }
            newUserKeys.forEach((key, index) => {
                let data = addictionData[key];
                let proportion = data['proportion'];
                this.charOption.newUserProportionOption.dataset[0].source
                    .push([key, data['percentage'], proportion, parseInt(data['timestamp']), data['currentUserCount'], data['totalUserCount']]);
            });
            
            // 新用户增长数量
            this.charOption.newUserNumberOption.dataset[0].source = [];
            this.charOption.newUserNumberOption.title.text = '最近' + this.newUserChartResult.chartName + '单日新增人数趋势';
            newUserKeys.forEach((key, index) => {
                let data = addictionData[key];
                let proportion = data['proportion'];
                this.everyDayNewUserMap.set(key, data);
                this.charOption.newUserNumberOption.dataset[0].source
                    .push([key, data['percentage'], proportion, parseInt(data['timestamp']), data['currentUserCount'], data['totalUserCount']]);
                if (index === newUserKeys.length - 1) {
                    this.chartLoadingStatus.newUserLoadingStatus = true;
                    this.charOption.showOptions = this.charOption.newUserNumberOption;
                    
                    // 排序
                    let everyDayNewUserList = Array.from(this.everyDayNewUserMap);
                    everyDayNewUserList.sort((a, b) => {
                        return new Date(a[0]) - new Date(b[0]);
                    });
                    this.everyDayNewUserMap = new Map(everyDayNewUserList);
                }
            })
        },
        handleEmptyData() {
            let dimensionList = this.newUserChartResult.dimensionDataList
            let emptyObject = {
                clientTagList: [],
                totalUserCount: 0,
                percentage: '0%',
                proportion: 0
            }
            dimensionList.forEach((key, index) => {
                this.charOption.newUserProportionOption.dataset[0].source.push([key, '0%', 0, index, [], 0, 0]);
            });
            
            // 新用户增长数量
            this.charOption.newUserNumberOption.dataset[0].source = [];
            this.charOption.newUserNumberOption.title.text = '最近' + this.newUserChartResult.chartName + '单日新增人数趋势';
            dimensionList.forEach((key, index) => {
                this.everyDayNewUserMap.set(key, emptyObject);
                this.charOption.newUserNumberOption.dataset[0].source.push([key, '0%', 0, index, [], 0, 0]);
                if (index === dimensionList.length - 1) {
                    this.chartLoadingStatus.newUserLoadingStatus = true;
                    this.charOption.showOptions = this.charOption.newUserNumberOption;
                    
                    // 排序
                    let everyDayNewUserList = Array.from(this.everyDayNewUserMap);
                    everyDayNewUserList.sort((a, b) => {
                        return new Date(a[0]) - new Date(b[0]);
                    });
                    this.everyDayNewUserMap = new Map(everyDayNewUserList);
                }
            })
        },
        loadClientTagList() {
            this.count += 2;
        },
        handleTimePickerBlur() {
            if (this.timePicker.pickerTimeValue.length === 0) {
                return
            }
            this.queryParams.startTime = this.timePicker.pickerTimeValue[0] + " 00:00:00"
            this.queryParams.endTime = this.timePicker.pickerTimeValue[1] + " 23:59:59"
            this.getList()
        },
        handleSelectedTrackProjectAppIdEvent(t) {
            this.queryParams.projectAppId = t
            this.$router.push(`/trackAnalyse/newUser/${t}`)
            this.setInitValue()
        },
        setInitValue() {
            this.queryParams.projectAppId = undefined
            this.queryParams.eventId = undefined
            if (this.$route.params.eventId && this.$route.params.eventId.indexOf('undefined') === -1) {
                this.queryParams.eventId = this.$route.params.eventId
            }
            if (this.$route.params.projectAppId && this.$route.params.projectAppId.indexOf('undefined') === -1) {
                this.queryParams.projectAppId = this.$route.params.projectAppId
            }
            if (!this.queryParams.projectAppId) {
                message.error('请选择项目!')
                return
            }
            this.getList()
        },
        handleTimeUnitChange() {
            this.getList()
        },
        queryNewUserList() {
            this.singleTimeUnitUser.queryParams.eventIdList = this.queryParams.eventIdList
            trackAnalyseApi.queryNewUserByTimeInterval(this.singleTimeUnitUser.queryParams).then(result => {
                if (result.code === 200) {
                    this.singleTimeUnitUser.queryParams.total = result.data.total
                    this.singleTimeUnitUser.queryParams.pageNum = result.data.pageNum
                    this.singleTimeUnitUser.queryParams.pageSize = result.data.pageSize
                    this.singleTimeUnitUser.userList = result.data.result
                }
            })
        },
        handleChangeCollapse(startTime) {
            this.singleTimeUnitUser.queryParams.timeUnitType = this.queryParams.timeUnitType
            this.singleTimeUnitUser.queryParams.startTimeStr = startTime
            this.singleTimeUnitUser.queryParams.projectAppId = this.queryParams.projectAppId
            this.singleTimeUnitUser.queryParams.pageNum = 1
            this.queryNewUserList()
        },
        handlePagination(pageNum) {
            this.singleTimeUnitUser.queryParams.pageNum = pageNum;
            this.queryNewUserList()
        },
    }
});
</script>

<style scoped lang='css'>
.new-user-client-tag {
    max-height: 20rem;
    overflow-y: scroll;
}

.new-user-client-tag li {
    margin-top: .5rem;
}
</style>